import axios from "axios";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "components";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { MdDelete } from "react-icons/md";
import { use } from "react";

const JobCardRejectionRecycleAdd = () => {
  const [workOrder, setWorkOrder] = useState([]);
  const [jobCardPendingList, setJobCardPendingList] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [itemsMaster, setItemsMaster] = useState([]);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [stockEntries, setStockEntries] = useState({});
  const [searchParameter, setSearchParameter] = useState("");

  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const headers = { headers: { Authorization: `Bearer ${token}` } };

  const workOrderGet = () => {
    axios
      .post(
        "/api/purple-fusion/jobcardproductionrejectiondetail/get/pending/workorder",
        {},
        headers
      )
      .then((res) => setWorkOrder(res.data))
      .catch(console.error);
  };

  const pendingJobWorkListGet = (workOrderId) => {
    axios
      .post(
        "/api/purple-fusion/jobcardproductionrejectiondetail/get/pending/items",
        { work_order_id: workOrderId },
        headers
      )
      .then((res) => setJobCardPendingList(res.data))
      .catch(console.error);
  };

  const fetchWarehouses = () => {
    axios
      .post("/api/purple-fusion/companywarehouse/get", {}, headers)
      .then((res) => setWarehouses(res.data))
      .catch(console.error);
  };

  const fetchItemsMaster = () => {
    axios
      .post(
        "/api/purple-fusion/itemdetail/getforsearch",
        { search_parameter: searchParameter },
        headers
      )
      .then((res) => {
        console.log(res.data);
        setItemsMaster(res.data || []);
      })
      .catch(console.error);
  };

  useEffect(() => {
    workOrderGet();
    fetchWarehouses();
    // fetchItemsMaster();
  }, []);
  useEffect(() => {
    fetchItemsMaster();
  }, [searchParameter]);

  const toggleItemSelection = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    setSelectedItems(
      selectedItems.length === jobCardPendingList.length
        ? []
        : jobCardPendingList.map((x) => x.job_card_production_id)
    );
  };

  const addStockEntry = (itemId) => {
    setStockEntries((prev) => {
      const list = prev[itemId] ? [...prev[itemId]] : [];
      list.push({
        item_detail_id: null,
        quantity: 0,
        warehouse_id: null,
        description: "",
      });
      return { ...prev, [itemId]: list };
    });
  };

  const updateStockEntry = (itemId, index, field, value) => {
    setStockEntries((prev) => {
      const list = prev[itemId] ? [...prev[itemId]] : [];
      list[index] = { ...list[index], [field]: value };
      return { ...prev, [itemId]: list };
    });
  };

  const removeStockEntry = (itemId, index) => {
    setStockEntries((prev) => {
      const list = prev[itemId] ? [...prev[itemId]] : [];
      list.splice(index, 1);
      return { ...prev, [itemId]: list };
    });
  };

  const handleSubmit = async (values) => {
    const payload = [];

    for (const item of jobCardPendingList) {
      const id = item.job_card_production_id;
      if (!selectedItems.includes(id)) continue;

      const { recycleQty, remarks } = values[id] || {};
      if (!Number(recycleQty) || Number(recycleQty) <= 0) continue;

      // use configured stock entries if present, otherwise create single entry
      const entries =
        stockEntries[id] && stockEntries[id].length > 0
          ? stockEntries[id]
          : [
              {
                item_detail_id: "",
                quantity: 0,
                warehouse_id: "",
                description: "",
              },
            ];

      // validate that each configured entry has a selected converted item
      // const missingItem = entries.find((e) => !e.item_detail_id);
      // if (missingItem) {
      //   toast.error(
      //     `Please select converted item for "${item.item_name}" before saving.`
      //   );
      //   return;
      // }
      for (const e of entries) {
        if (!e.item_detail_id) {
          toast.error(`Please add converted item `);
          return;
        }

        if (!e.quantity || e.quantity <= 0) {
          toast.error(`Please enter valid quantity for converted item `);
          return;
        }

        if (!e.warehouse_id) {
          toast.error(`Please select warehouse for converted item `);
          return;
        }
      }

      payload.push({
        job_card_production_id: id,
        item_detail_id: item.item_detail_id,
        company_warehouse_id: selectedWarehouse,
        job_card_rejection_type_id: 4, // Recycle (assumed)
        quantity: Number(recycleQty),
        remarks: remarks || "",
        // createdby: sessionStorage.getItem("id")
        //   ? Number(sessionStorage.getItem("id"))
        //   : null,
        stock_transaction_jsonb: entries,
      });
    }

    if (payload.length === 0) {
      toast.error(
        "Please select at least one item and enter recycle quantity!"
      );
      return;
    }

    if (!selectedWarehouse) {
      toast.error("Please select a Warehouse for Recycle items!");
      return;
    }
    console.log(payload);

    try {
      const res = await axios.post(
        "/api/purple-fusion/jobcard-rejection/recycle/create",
        payload,
        headers
      );
      const message = res.data?.message || "Saved";
      if (res.data?.status) {
        toast.success(message, {
          autoClose: 2000,
          onClose: () => navigate(`/JobCardProductionRejectionDetailList`),
        });
      } else {
        toast.error(message || "Failed to save");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error");
    }
  };

  return (
    <>
      <Formik initialValues={{}} onSubmit={handleSubmit}>
        {() => (
          <Form>
            <div className="flex justify-between items-center border-b pb-2 mb-4">
              <h2 className="text-lg font-semibold">Job Card Recycle Entry</h2>
              <div className="flex gap-2">
                <Button
                  type="submit"
                  className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg"
                  shape="round"
                  color="blue_A700"
                  size="base"
                  variant="fill"
                >
                  Save
                </Button>
              </div>
            </div>

            <div className="flex flex-row justify-start gap-6 mb-4">
              <div className="flex flex-col w-60">
                <label className="font-medium mb-1 text-sm">
                  Select Work Order:
                </label>
                <Select
                  value={
                    selectedWorkOrder
                      ? {
                          value: selectedWorkOrder,
                          label:
                            workOrder.find(
                              (wo) => wo.work_order_id === selectedWorkOrder
                            )?.work_order_code || "",
                        }
                      : null
                  }
                  onChange={(selected) => {
                    const id = parseInt(selected.value);
                    setSelectedWorkOrder(id);
                    pendingJobWorkListGet(id);
                    setSelectedItems([]);
                  }}
                  options={workOrder.map((wo) => ({
                    value: wo.work_order_id,
                    label: wo.work_order_code,
                  }))}
                  placeholder="-- Select Work Order --"
                  className="text-xs"
                />
              </div>

              <div className="flex flex-col w-60">
                <label className="font-medium mb-1 text-sm">Warehouse:</label>
                <Select
                  value={
                    selectedWarehouse
                      ? {
                          value: selectedWarehouse,
                          label:
                            warehouses.find((wh) => wh.id === selectedWarehouse)
                              ?.warehouse_name || "",
                        }
                      : null
                  }
                  onChange={(selected) => setSelectedWarehouse(selected.value)}
                  options={warehouses.map((wh) => ({
                    value: wh.id,
                    label: wh.warehouse_name,
                  }))}
                  placeholder="-- Select Warehouse --"
                  className="text-xs"
                />
              </div>
            </div>

            {jobCardPendingList.length > 0 && (
              <table className="w-full border-collapse border text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border p-2 text-sm">
                      <input
                        type="checkbox"
                        checked={
                          selectedItems.length === jobCardPendingList.length
                        }
                        onChange={toggleSelectAll}
                        className="rounded-sm"
                      />
                    </th>
                    <th className="border p-2 text-sm">Item Name</th>
                    <th className="border p-2 text-sm">Rejected Qty</th>
                    <th className="border p-2 text-sm">Remaining</th>
                    <th className="border p-2 text-sm">Recycle Qty</th>
                    <th className="border p-2">Remarks</th>
                    <th className="border p-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {jobCardPendingList.map((item) => {
                    const id = item.job_card_production_id;
                    const checked = selectedItems.includes(id);
                    return (
                      <React.Fragment key={id}>
                        <tr>
                          <td className="border text-center px-1 text-xs">
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => toggleItemSelection(id)}
                              className="rounded-sm"
                            />
                          </td>
                          <td className="border px-1 text-xs">
                            {item.item_name}
                          </td>
                          <td className="border text-center px-1 text-xs">
                            {item.quantity_rejected_for_quality_check}
                          </td>
                          <td className="border text-center px-1 text-xs">
                            {item.remaining_quantity_to_insert}
                          </td>
                          <td className="border text-center px-1 text-xs">
                            <Field
                              type="number"
                              name={`${id}.recycleQty`}
                              disabled={!checked}
                              min="0"
                              max={item.remaining_quantity_to_insert}
                              className="border rounded p-1 w-16 text-center disabled:bg-gray-100 h-7 text-xs"
                            />
                          </td>
                          <td className="border px-1 text-xs text-center align-middle">
                            {/* <div className="flex flex-col items-center gap-2"> */}
                            <Field
                              type="text"
                              name={`${id}.remarks`}
                              disabled={!checked}
                              placeholder="Remarks"
                              className="border text-xs rounded p-1 w-36 h-7 text-center disabled:bg-gray-100"
                            />

                            {/* </div> */}
                          </td>
                          <td>
                            {checked && (
                              <button
                                type="button"
                                className="text-xs p-1 m-1 rounded-md  text-white-A700 underline border bg-green-500  "
                                onClick={() => addStockEntry(id)}
                              >
                                Add Stock Item
                              </button>
                            )}
                          </td>
                        </tr>

                        {checked && (
                          <tr key={`${id}-stock`} className="bg-gray-50">
                            <td colSpan={6} className="p-2 border">
                              <div className="flex flex-col gap-2">
                                {(stockEntries[id] || []).map((se, idx) => (
                                  <div
                                    key={idx}
                                    className="flex gap-2 items-center"
                                  >
                                    <Select
                                      value={
                                        se.item_detail_id
                                          ? {
                                              value: se.item_detail_id,
                                              label: itemsMaster.find(
                                                (it) =>
                                                  it.id === se.item_detail_id
                                              )?.name,
                                            }
                                          : null
                                      }
                                      onChange={(opt) =>
                                        updateStockEntry(
                                          id,
                                          idx,
                                          "item_detail_id",
                                          opt ? opt.value : null
                                        )
                                      }
                                      options={itemsMaster.map((it) => ({
                                        value: it.id,
                                        label:
                                          it.name +
                                          " (" +
                                          it?.code_op +
                                          ")" +
                                          (it.code ? " - " + it.code : ""),
                                      }))}
                                      onInputChange={(inputValue) => {
                                        setSearchParameter(inputValue);
                                      }}
                                      className="w-60 text-xs"
                                      placeholder="-- Select Item --"
                                    />

                                    <input
                                      type="number"
                                      value={se.quantity}
                                      min="0"
                                      onChange={(e) =>
                                        updateStockEntry(
                                          id,
                                          idx,
                                          "quantity",
                                          Number(e.target.value)
                                        )
                                      }
                                      className="border rounded p-1 w-24 text-center h-9 text-xs"
                                      placeholder="Qty"
                                    />

                                    <Select
                                      value={
                                        se.warehouse_id
                                          ? {
                                              value: se.warehouse_id,
                                              label: warehouses.find(
                                                (w) => w.id === se.warehouse_id
                                              )?.warehouse_name,
                                            }
                                          : null
                                      }
                                      onChange={(opt) =>
                                        updateStockEntry(
                                          id,
                                          idx,
                                          "warehouse_id",
                                          opt ? opt.value : null
                                        )
                                      }
                                      options={warehouses.map((wh) => ({
                                        value: wh.id,
                                        label: wh.warehouse_name,
                                      }))}
                                      className="w-60 text-xs"
                                      placeholder="-- Select Warehouse --"
                                    />

                                    <input
                                      type="text"
                                      value={se.description}
                                      onChange={(e) =>
                                        updateStockEntry(
                                          id,
                                          idx,
                                          "description",
                                          e.target.value
                                        )
                                      }
                                      placeholder="Description"
                                      className="border rounded p-1 w-60 h-9 text-xs"
                                    />

                                    <button
                                      type="button"
                                      className="text-red-600 mx-2"
                                      onClick={() => removeStockEntry(id, idx)}
                                    >
                                      <MdDelete size={20} />
                                    </button>
                                  </div>
                                ))}

                                {/* <div>
                                  <button
                                    type="button"
                                    className="text-sm text-blue-600 underline"
                                    onClick={() => addStockEntry(id)}
                                  >
                                    + Add Stock Item
                                  </button>
                                </div> */}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Form>
        )}
      </Formik>

      <ToastContainer />
    </>
  );
};

export default JobCardRejectionRecycleAdd;
